<div class="d-flex flex-row gap-2">
  <span>{{ params.title }}</span>
  <i #p="ngbPopover" [class]="params.iconClass" style="cursor: pointer;" [ngbPopover]="popupContent"
     [popoverClass]="params.popoverClass" [placement]="params.placement" [triggers]="params.trigger" container="body"
     (click)="togglePopover(p)"></i>
</div>

<ng-template #popupContent>
  <div class="d-felx flex-column" >
    <div [innerHTML]="params.contentHtml"></div>
  </div>
</ng-template>